<h5 class="text-primary mb-3">Fan</h5>
@if (fanspeed(); as fanspeed) {
  <div class="fanspeed">
    <div class="bars d-flex align-items-end">
      <div class="bar text-center text-primary">
        @if (fanspeed.FanSpeedCode === 'Off') {
          <fa-icon icon="toggle-off"></fa-icon>
        } @else {
          <fa-icon icon="toggle-on"></fa-icon>
        }
      </div>
      <div class="bar bg-primary bar-low"
           [class.bg-secondary]="fanspeed.FanSpeedCode === 'Low'"></div>
      <div class="bar bg-primary bar-medium"
           [class.bg-secondary]="fanspeed.FanSpeedCode === 'Medium'"></div>
      <div class="bar bg-primary bar-high"
           [class.bg-secondary]="fanspeed.FanSpeedCode === 'High'"></div>
    </div>
    <div class="labels d-flex align-items-end">
      <div class="label small text-center">
        @if (fanspeed.FanSpeedCode === 'Off') {
          <span>OFF</span>
        } @else {
          <span>ON</span>
        }
      </div>
      <div class="label small text-center">LOW</div>
      <div class="label small text-center">MED</div>
      <div class="label small text-center">HIGH</div>
    </div>
  </div>
} @else {
  There is no fanspeed available for this room.
}